import React from "react"
import { List } from "@material-ui/core"
import { Menu } from './styles'
import { makeStyles } from '@material-ui/core/styles'
import ListSubheader from '@material-ui/core/ListSubheader'
import MenuSideItem from './menuSideItem'

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
}))

export default function MenuSide({ subMenus }) {
  const classes = useStyles()
  return (
    <>
    {(subMenus.length > 0) && (
      <Menu id="Menu">
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          subheader={
            <ListSubheader component="div" id="nested-list-subheader">MENU</ListSubheader>
          }
          className={classes.root}
        >
          {subMenus.map((sidebarItem, index) => (
            <MenuSideItem
              key={`${sidebarItem.descricao}${index}`}
              item={sidebarItem}
            />
          ))}
        </List>
      </Menu>
      ) }  
    </>  
  )
}